export default __webpack_public_path__ + "static/media/daniel.68f9d506.jpg";